export class AuthorEPTInstructionModel {
  GetDataProofingEPT: any;
  GetDataProofingEPTById: any;
  AddUpdateProofingInstruction: any;
  GetPublisher: any;
}
